export default __webpack_public_path__ + "static/media/teach_one.4175011d.png";